import { ScreenLoading } from '@/components/loading';
import { ScreenDocuments, ScreenDocumentsError } from '@/components/screens/documents-screen';
import { useApplications, useMe } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function DocumentsPage() {
  const sp = useScreenProps();
  const { data: apps, isLoading, isError, refetch } = useApplications();
  const { data: me } = useMe();
  const role = me?.role === 'admin' ? 'admin' : 'collab';

  // Erro sem dado em cache: tela com retry — nunca spinner infinito.
  if (isError && !apps) {
    return (
      <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
        <ScreenDocumentsError {...sp} role={role} onRetry={() => void refetch()} />
      </div>
    );
  }
  if (isLoading || !apps) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenDocuments {...sp} apps={apps} role={role} />
    </div>
  );
}
